import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";
import { decryptData } from "../../_services/encDnc";

const SelectedAddress = (props) => {
    const { userAddressByLoginAddressId } = props;

    return (
        <div >
            {userAddressByLoginAddressId && userAddressByLoginAddressId != null ?
                <div>
                    <div className="box-border">
                        <>
                            <div className="d-flex justify-content-between align-items-start">
                                <div className="loginid_data d-flex align-items-start">
                                    <div className="loginid_address">
                                        <span className="userName_address address_description">{userAddressByLoginAddressId?.name}</span>
                                        <h6 className="py-sm-2 address_description mb-0">{userAddressByLoginAddressId?.contatctNo}</h6>
                                        <span className="mb-0 address_description">
                                            {userAddressByLoginAddressId?.addressLine1} {userAddressByLoginAddressId?.addressLine2} {userAddressByLoginAddressId?.city} {userAddressByLoginAddressId?.stateName} {userAddressByLoginAddressId?.countryName} {userAddressByLoginAddressId?.pincode}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                    <div className="add_more_address_btn mt-2">
                        <Link to='/shipping-address' className="">Change Address</Link>
                    </div>
                </div>
                :
                null
            }
        </div>
    )
}

export default SelectedAddress;